import { render, staticRenderFns } from "./save-project.vue?vue&type=template&id=006dc553"
import script from "./save-project.vue?vue&type=script&lang=js"
export * from "./save-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports